import React, { useEffect, useRef, useCallback} from "react";


function InterSectionObserver({dataLoading, onHandleObserver}) {
  const row = useRef();

  const handleObserver = useCallback((entries) => {
    const target = entries[0];
    if (target.isIntersecting) {
      onHandleObserver();
    }
  }, [onHandleObserver]);

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "20px",
      threshold: 0
    };
    const observer = new IntersectionObserver(handleObserver, option);
    if (!dataLoading && row.current) {
      observer.observe(row.current);
    } else {
      observer.disconnect();
    }
    return () => {
      observer.disconnect();
    }
  }, [dataLoading, handleObserver]);


  return (
    <div ref={row}/>
  )
}
export default InterSectionObserver;
